

export enum EProductType {
  anPostDsu = "an-post-dsu",
  banking = "banking",
  brandHome = "brandHome",
  facilities = "facilities",
  failteIrelandAccommodation = "failte-ireland-accommodation",
  failteIrelandRetail = "failte-ireland-retail",
  foodAndBeverage = "food-and-beverage",
  generic = "generic",
  manufacturing = "manufacturing",
  manufacturingCampus = "manufacturing-campus",
  postOffice = "post-office",
  publicRealm = "public-realm",
  retail = "retail",
}


